// Inhalte der neuen Startseite, deutsch und englisch an einer Stelle.
// Preise wie im Shop (ProductDetail / AllInOne): Module 14,99 €, Instant Grade und
// Instant Comp 24,99 €, All-in-One 15,99 €/Monat oder 159 €/Jahr.

// [slug, Name, Kategorie, Preis, Text DE, Text EN] — auch die Produktseiten lesen hier ihren Einzeiler
export const WERKZEUGE = [
  ['instant-curve', 'Instant Curve', 'animation', 14.99, 'Easing-Kurven auf Keyframes: Vorlage antippen, anwenden, fertig.', 'Easing curves on keyframes: tap a preset, apply, done.'],
  ['bounce-flow', 'Bounce Flow', 'animation', 14.99, 'Federndes Nachschwingen für jede Bewegung.', 'Springy overshoot for any motion.'],
  ['shake-flow', 'Shake Flow', 'animation', 14.99, 'Wackeln und Zittern, von der Handkamera bis zum Einschlag.', 'Shakes and jitters, from handheld camera to impact.'],
  ['glitch-flow', 'Glitch Flow', 'animation', 14.99, 'Digitale Störungen: RGB-Versatz, Blöcke, Bildrauschen.', 'Digital distortion: RGB split, blocks, noise.'],
  ['text-flow', 'Text Flow', 'text', 14.99, 'Textanimationen, Untertitel und Textboxen.', 'Text animations, subtitles and text boxes.'],
  ['grid-flow', 'Grid Flow', 'layout', 14.99, 'Raster aus Ebenen: Abstände, Reihen, Spalten.', 'Grids from layers: spacing, rows, columns.'],
  ['carousel-flow', 'Carousel Flow', 'layout', 14.99, 'Kreisende Karussells in 2D und 3D.', 'Rotating carousels in 2D and 3D.'],
  ['shape-flow', 'Shape Flow', 'layout', 14.99, 'Formebenen erzeugen und animieren.', 'Create and animate shape layers.'],
  ['background-flow', 'Background Flow', 'layout', 14.99, 'Animierte Hintergründe und Verläufe.', 'Animated backgrounds and gradients.'],
  ['instant-ui-kit', 'Instant UI Kit', 'layout', 14.99, 'UI-Elemente und App-Screens als echte AE-Ebenen.', 'UI elements and app screens as real AE layers.'],
  ['instant-grade', 'Instant Grade', 'farbe', 24.99, 'Color-Grading direkt in After Effects.', 'Color grading right inside After Effects.'],
  ['instant-comp', 'Instant Comp', 'bausteine', 24.99, 'Eigene Comps als Bausteine sichern und per Klick einsetzen.', 'Save your own comps as building blocks, drop them in with one click.'],
];

// [slug, Name, Text DE, Text EN]
export const GRATIS = [
  ['text-animations', '5+ Text Animations', '5+ Text-Animationen als .ffx-Presets: per Drag & Drop auf jede Text-Ebene, inklusive Projekt.', '5+ text animations as .ffx presets: drag & drop onto any text layer, project included.'],
  ['text-animations-2', '5+ Text Animations 2', '5+ weitere Text-Animationen, kein Plugin nötig, inklusive Projekt.', '5+ more text animations, no plugin needed, project included.'],
  ['animated-gradients', '10+ Animated Gradients', '10+ animierte Verläufe für Hintergründe, Übergänge und Overlays, frei anpassbar.', '10+ animated gradients for backgrounds, transitions and overlays, fully adjustable.'],
];

// Die Ansichten, die im All-in-One-Abschnitt durchlaufen (echte Studio-Flow-Screenshots, als WebP neben den JPGs)
export const PANELS = [
  ['Instant Curve', '/startseite/panel/instant-curve.webp'],
  ['Bounce', '/startseite/panel/bounce-flow.webp'],
  ['Shake', '/startseite/panel/shake-flow.webp'],
  ['Text', '/startseite/panel/text-flow.webp'],
  ['Grid', '/startseite/panel/grid-flow.webp'],
  ['Carousel', '/startseite/panel/carousel-flow.webp'],
];

const euro = (en, v, stellen = 2) => {
  const z = v.toFixed(stellen);
  return en ? '€' + z : z.replace('.', ',') + '\u00a0€';
};

export function texte(en) {
  const summe = WERKZEUGE.reduce((s, w) => s + w[3], 0);
  const ab = Math.min(...WERKZEUGE.map(w => w[3]));
  const de = !en;
  return {
    werkzeuge: WERKZEUGE.map(([slug, name, kat, preis, tDe, tEn]) => ({ slug, name, kat, preis: euro(en, preis), text: de ? tDe : tEn })),
    gratis: GRATIS.map(([slug, name, tDe, tEn]) => ({ slug, name, text: de ? tDe : tEn, kat: slug === 'animated-gradients' ? 'footage' : 'presets' })),
    // Kopfbereich = Header-Version 11 der Demo
    hero: {
      kicker: de ? 'Extensions für After Effects' : 'Extensions for After Effects',
      h1a: de ? 'Ein Klick statt' : 'One click instead of',
      h1b: de ? 'zwanzig Keyframes.' : 'twenty keyframes.',
      punkte: de
        ? [[String(WERKZEUGE.length), 'Werkzeuge', 'für After Effects, Panels auf Deutsch'], ['1 Klick', 'Vorlage', 'wählen, anwenden, fertig'], ['Ein', 'Installer', 'alles an einem Ort, immer aktuell']]
        : [[String(WERKZEUGE.length), 'tools', 'for After Effects'], ['1 click', 'presets', 'pick, apply, done'], ['One', 'installer', 'everything in one place, always up to date']],
      cta1: de ? 'Gratis-Installer laden' : 'Get the free installer',
      cta2: de ? 'All-in-One 7 Tage testen' : 'Try All-in-One for 7 days',
    },
    wz: {
      kicker: de ? '01 · Werkzeuge' : '01 · Tools',
      h2a: de ? 'Zwölf Werkzeuge.' : 'Twelve tools.',
      h2b: de ? 'Jedes spart dir einen Arbeitsschritt.' : 'Each one saves you a step.',
      lead: de
        ? `Einzeln ab ${euro(en, ab)} als Einmalkauf, oder alle zusammen im All-in-One.`
        : `From ${euro(en, ab)} each as a one-time purchase, or all of them in the All-in-One.`,
      chips: [['alle', de ? 'Alle' : 'All'], ['animation', 'Animation'], ['text', 'Text'], ['layout', 'Layout'], ['farbe', de ? 'Farbe' : 'Color'], ['bausteine', de ? 'Bausteine' : 'Building blocks']],
      abo: de ? 'Im All-in-One enthalten' : 'Included in All-in-One',
      ansehen: de ? 'Ansehen →' : 'View →',
    },
    // nur auf der Werkzeuge-Seite unter „Kostenlos“
    flowPanel: { slug: 'flow-panel', kat: 'extension', name: 'Flow Panel', text: de ? 'Deine installierten Werkzeuge in einem Fenster, ein Klick zum Öffnen.' : 'Your installed tools in one window, one click to open.', abo: de ? 'Kostenlos · im Installer' : 'Free · in the installer' },
    gr: {
      kicker: de ? '02 · Kostenlos' : '02 · Free',
      h2a: de ? 'Gratis zum Reinschnuppern.' : 'Free to try.',
      h2b: de ? 'Laden und loslegen.' : 'Download and go.',
      lead: de
        ? 'Eine Extension, Presets und Footage für After Effects, kostenlos: direkt als .zip oder mit deinem Konto im Installer.'
        : 'An extension, presets and footage for After Effects, free: download the .zip directly or get them with your account in the installer.',
      preis: de ? 'Gratis' : 'Free',
      abo: de ? 'Kostenlos · .zip oder Installer' : 'Free · .zip or installer',
      // nur auf der Kostenlos-Seite
      chips: [['alle', de ? 'Alle' : 'All'], ['extension', 'Extension'], ['presets', 'Presets'], ['footage', 'Footage']],
    },
    aio: {
      kicker: '03 · All-in-One',
      h2a: de ? 'Alle Werkzeuge.' : 'Every tool.',
      h2b: de ? 'Ein Panel.' : 'One panel.',
      lead: de
        ? 'Im All-in-One steckt Studio Flow: alle Werkzeuge zusammen in einem einzigen Panel. Das gibt es nur hier. Dazu Instant Grade, Instant Comp und jedes neue Werkzeug, sobald es fertig ist.'
        : 'The All-in-One includes Studio Flow: every tool together in a single panel. You only get it here. Plus Instant Grade, Instant Comp and every new tool as soon as it is ready.',
      monatlich: de ? 'Monatlich' : 'Monthly',
      jaehrlich: de ? 'Jährlich' : 'Yearly',
      haken: de
        ? ['Studio Flow: ein Panel statt zehn', 'Instant Grade und Instant Comp inklusive', 'Jedes neue Werkzeug automatisch dabei']
        : ['Studio Flow: one panel instead of ten', 'Instant Grade and Instant Comp included', 'Every new tool included automatically'],
      anker: de
        ? `Einzeln kosten alle Werkzeuge zusammen ${euro(en, summe)}. Studio Flow gibt es einzeln gar nicht.`
        : `Bought separately, all tools together cost ${euro(en, summe)}. Studio Flow isn't sold separately at all.`,
      testen: de ? '7 Tage kostenlos testen' : 'Start 7-day free trial',
      mikro: de ? 'In den 7 Tagen wird nichts abgebucht. Jederzeit kündbar.' : 'No charge during the trial. Cancel any time.',
    },
    preise: {
      jahr: { betrag: 159, einheit: de ? '/ Jahr' : '/ year', unter: de ? `nur ${euro(en, 159 / 12)} im Monat · 2 Monate geschenkt` : `only ${euro(en, 159 / 12)} a month · 2 months free`, format: v => euro(en, v, 0) },
      monat: { betrag: 15.99, einheit: de ? '/ Monat' : '/ month', unter: de ? 'monatlich kündbar' : 'billed monthly, cancel anytime', format: v => euro(en, v) },
    },
    inst: {
      kicker: '04 · Installer',
      h2a: de ? 'Einmal installieren.' : 'Install once.',
      h2b: de ? 'Alles an einem Ort.' : 'Everything in one place.',
      lead: de
        ? 'Der David Media Installer ist kostenlos. Er richtet alles ein, was du besitzt, und hält es aktuell.'
        : 'The David Media Installer is free. It sets up everything you own and keeps it up to date.',
      schritte: de
        ? [['Installer laden', ' für Mac oder Windows.'], ['Mit deinem Konto anmelden.', ' Das Konto ist kostenlos.'], ['In After Effects öffnen:', ' Fenster › Erweiterungen.']]
        : [['Download the installer', ' for Mac or Windows.'], ['Sign in with your account.', ' The account is free.'], ['Open it in After Effects:', ' Window › Extensions.']],
      mac: de ? 'Für Mac laden' : 'Download for Mac',
      win: de ? 'Für Windows laden' : 'Download for Windows',
      zeilen: [
        { bild: '/startseite/studioflow.jpg', name: 'Studio Flow', klein: 'All-in-One · v1.1.15', status: 'ok', em: de ? 'Installiert' : 'Installed' },
        { bild: `/products/titel/${de ? '' : 'en/'}800/instant-grade.webp`, name: 'Instant Grade', klein: de ? 'Update verfügbar' : 'Update available', status: 'upd', em: de ? 'Aktualisieren' : 'Update', fertig: de ? 'Aktuell' : 'Up to date', kleinFertig: de ? 'All-in-One · aktualisiert' : 'All-in-One · updated' },
        { bild: `/products/titel/${de ? '' : 'en/'}800/instant-comp.webp`, name: 'Instant Comp', klein: 'All-in-One', status: 'ok', em: de ? 'Installiert' : 'Installed' },
        { bild: `/products/titel/${de ? '' : 'en/'}800/flow-panel.webp`, name: 'Flow Panel', klein: de ? 'Gratis' : 'Free', status: 'ok', em: de ? 'Installiert' : 'Installed' },
        { bild: `/products/titel/${de ? '' : 'en/'}800/animated-gradients.webp`, name: 'Animated Gradients', klein: de ? 'Gratis-Footage' : 'Free footage', status: 'ok', em: de ? 'Installiert' : 'Installed' },
        { bild: '/startseite/text.jpg', name: de ? 'Text-Animationen' : 'Text animations', klein: de ? 'Gratis-Presets' : 'Free presets', status: 'neu', em: de ? 'Installieren' : 'Install', fertig: de ? 'Installiert' : 'Installed' },
      ],
      angemeldet: de ? 'Angemeldet · All-in-One' : 'Signed in · All-in-One',
      offen: de ? '2 Aktionen offen' : '2 actions pending',
    },
    // Texte, die das Installer-Fenster beim Durchlaufen setzt
    szene: {
      laedt: de ? 'Lädt …' : 'Loading …',
      aktualisiert: de ? 'Aktualisiert …' : 'Updating …',
      allesAktuell: de ? 'Alles aktuell' : 'All up to date',
      eineAktion: de ? '1 Aktion offen' : '1 action pending',
    },
  };
}
